import { IApplicationContext } from '../../../types/applicationContext';
import {
  fetchReceiptDetailsSave,
  type TReceiptDetailsSaveRequest,
  type TReceiptDetailsSaveResponse,
} from '../../../repositories/dailyrent/v1/receipt-details/save';
import { ValidationError } from '@cian/peperrors';
import { IErrorResponseSchema } from 'shared/repositories/dailyrent/entities/schemas/ErrorResponseSchema';

export type TSaveFormDataValidationErrorKey = 'inn' | 'email' | 'phone' | 'lastName' | 'firstName' | 'patronymic';
export type TSaveFormDataValidationError = { key: TSaveFormDataValidationErrorKey; code: string; message: string };
export type TSaveFormDataValidationErrorDetails = Record<TSaveFormDataValidationErrorKey, string>;

/**
 * Ловит ошибки валидации и возвращает ValidationError. Иначе возвращает общую ошибку
 */
const getValidationOrUnknownError = (response: IErrorResponseSchema) => {
  const { message, errors } = response;

  if ('message' in response && errors?.length) {
    const typedErrors = errors as TSaveFormDataValidationError[];

    const validationDetails = typedErrors.reduce((acc, error: TSaveFormDataValidationError) => {
      return { ...acc, [error.key]: error.message };
    }, {} as TSaveFormDataValidationErrorDetails);

    if (Object.keys(validationDetails).length > 0) {
      return new ValidationError({
        message: message ?? 'Ошибка валидации',
        domain: '/v1/receipt-details/save/',
        details: validationDetails,
      });
    }
  }

  return new Error('Неизвестная ошибка');
};

export async function fetchSaveFormData(context: IApplicationContext, parameters: TReceiptDetailsSaveRequest) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: TReceiptDetailsSaveResponse = await fetchReceiptDetailsSave({
      httpApi,
      parameters,
    });

    if (statusCode === 400) {
      throw getValidationOrUnknownError(response);
    }

    return response as TReceiptDetailsSaveResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
